import React from 'react';
import './Header.css'

const Header = () => {
    return (
        <div className='header_section'>
            <h1>Painting Gallery</h1>
            <h2>Choose your Painting</h2>
        </div>
    );
};

export default Header;